import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppBar, Box, Button, Icon, Tab, Tabs, Tooltip, Typography } from '@mui/material'
import ITAdminSettingsTable from './SettingsTable'
import { RootState } from '../../reducers'
import { ITAdminSettingsTableHeader } from './SettingsTableHeader'
import { ITAdminSettingsStateList } from './SettingsTableHeader'

import { TabPanelProps } from '../../interfaces/inbox'
import { useStyles } from '../CaseWorklist/Pathologist/inboxStyles'
import { getHolidayData } from '../../../src/actions'
import HolidayTable from './HolidayTable'
import StatesTable from './StatesTable'

function a11yProps(index: unknown) {
  return {
    id: `case-worklist-${index}`,
    'aria-controls': `case-worklist-${index}`,
  }
}

export function ITAdminSettings({ user, role }): JSX.Element {
  const classes = useStyles()
  const [value, setValue] = useState(0)
  const [addProcedureCode, setAddProcedureCode] = useState(false)
  const holidayData = useSelector((state: RootState) => state.addHolidayData)
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  const [header, setHeader] = useState('')

  function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`case-worklist-${index}`}
        aria-labelledby={`case-worklist-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={0} pt={1}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    )
  }
  useEffect(() => {
    dispatch(getHolidayData())
  }, [dispatch])

  const handleChange = (event, newValue: number) => {
    if (newValue === undefined) return
    setValue(newValue)
  }

  const handleOpen = (headerName) => {
    setHeader(headerName)
    setOpen(true)
  }
  const handleClose = () => setOpen(false)
  function enableAddProcedureCode() {
    setAddProcedureCode(true)
  }

  function disableAddProcedureCode() {
    setAddProcedureCode(false)
  }

  const handleOpenEdit = (headerName, params) => {
    setParamsInfo(params)
    setHeader(headerName)
    setOpen(true)
    setInfoPassed(true)
  }

  return (
    <div>
      <Box>
        <AppBar position="static" className={classes.appBar}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="case-worklist"
            classes={{
              indicator: classes.indicator,
            }}
          >
            <Tab
              label="Procedure codes "
              onClick={enableAddProcedureCode}
              {...a11yProps(1)}
              style={{ margin: '0px 10px' }}
            />
            <Tab label="States" onClick={disableAddProcedureCode} {...a11yProps(0)} style={{ margin: '0px 10px' }} />
            <Tab label="US-Holidays" style={{ margin: '0px 10px' }} />
          </Tabs>
        </AppBar>
        <TabPanel value={value} index={0}>
          <ITAdminSettingsTable userId={206} tableColumns={ITAdminSettingsTableHeader} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          {/* <Box sx={{ flexGrow: 1 }}>
            <img
              src={'https://www.pngkit.com/png/detail/88-880178_new-look-blog-site-under-construction-svg.png'}
              width="350"
            />
          </Box> */}
          <StatesTable userId={206} tableColumns={ITAdminSettingsStateList} />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <HolidayTable />
        </TabPanel>
      </Box>
    </div>
  )
}
function setParamsInfo(params: any) {
  throw new Error('Function not implemented.')
}

function setInfoPassed(arg0: boolean) {
  throw new Error('Function not implemented.')
}
